import React from "react";
import { Alert } from "react-bootstrap";

function withError(Component) {
  return function WihErrorComponent({ hasError, errorMsg, ...props }) {
    if (hasError) return <Alert variant="danger">{errorMsg}</Alert>;
    return <Component {...props} />;
  };
}
export default withError;
